import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import { ConnectionLogEntry, ConnectionLogService } from '@services/connection-log.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-connection-logs-modal',
  templateUrl: './connection-logs-modal.component.html',
  styleUrls: ['./connection-logs-modal.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule, TranslateModule]
})
export class ConnectionLogsModalComponent implements OnInit {
  logs: ConnectionLogEntry[] = [];
  filteredLogs: ConnectionLogEntry[] = [];
  selectedFilter: 'all' | 'connection' | 'disconnection' | 'reconnection' | 'error' = 'all';
  stats: any = {};

  constructor(
    private modalCtrl: ModalController,
    private logService: ConnectionLogService
  ) { }

  ngOnInit() {
    this.loadLogs();
  }

  loadLogs() {
    this.logs = this.logService.getLogs();
    this.stats = this.logService.getConnectionStats();
    this.applyFilter();
  }

  applyFilter() {
    if (this.selectedFilter === 'all') {
      this.filteredLogs = this.logs;
    } else {
      this.filteredLogs = this.logs.filter(log => log.type === this.selectedFilter);
    }
  }

  setFilter(filter: 'all' | 'connection' | 'disconnection' | 'reconnection' | 'error') {
    this.selectedFilter = filter;
    this.applyFilter();
  }

  clearLogs() {
    this.logService.clearLogs();
    this.loadLogs();
  }

  exportLogs() {
    const text = this.logService.exportLogsAsText();
    const blob = new Blob([text], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `connection-logs-${new Date().toISOString()}.txt`;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  close() {
    this.modalCtrl.dismiss();
  }

  getLogIcon(type: ConnectionLogEntry['type']): string {
    switch (type) {
      case 'connection': return 'checkmark-circle';
      case 'disconnection': return 'warning';
      case 'reconnection': return 'reload';
      case 'error': return 'close-circle';
      default: return 'information-circle';
    }
  }

  getLogColor(type: ConnectionLogEntry['type']): string {
    switch (type) {
      case 'connection': return 'success';
      case 'disconnection': return 'warning';
      case 'reconnection': return 'tertiary';
      case 'error': return 'danger';
      default: return 'medium';
    }
  }

  formatTimestamp(date: Date): string {
    return new Date(date).toLocaleString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  }

  formatDetails(details: any): string {
    if (!details) return '';
    try {
      return JSON.stringify(details, null, 2);
    } catch {
      return String(details);
    }
  }
}

